import React from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@/components/controls/Tabs";
import { createSwitchOptions } from "../shared";
import { asString, ControlProps } from "../types";

export const SwitchControl: React.FC<ControlProps> = ({
  config,
  value,
  onChange,
  name
}) => {
  const { t } = useTranslation();
  const options = createSwitchOptions(config, t);

  // Stored value only, so an unanswered switch renders nothing selected.
  return (
    <div className="w-fit">
      <Tabs
        options={options}
        value={asString(value)}
        valueSelected={onChange}
        size="lg"
        dataTest={`${name}-switch`}
      />
    </div>
  );
};
